module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "新增课前预习",
      "width": "1000px"
    },
    on: {
      "on-ok": _vm.saveData
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "previewForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.previewRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本",
      "prop": "version"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": ""
    },
    on: {
      "on-change": _vm.onVersionChange
    },
    model: {
      value: (_vm.formData.version),
      callback: function($$v) {
        _vm.$set(_vm.formData, "version", _vm._n($$v))
      },
      expression: "formData.version"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择开始Level",
      "prop": "levelId",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onLevelChange
    },
    model: {
      value: (_vm.formData.levelId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "levelId", $$v)
      },
      expression: "formData.levelId"
    }
  }, _vm._l((_vm.levels), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择对应课程",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formData.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lessonId", $$v)
      },
      expression: "formData.lessonId"
    }
  }, _vm._l((_vm.lessons), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": ""
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("预览")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('quillEditor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "change": _vm.textChange
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  }), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "action": _vm.action,
      "before-upload": _vm.beforeUpload,
      "headers": _vm.headers,
      "accept": _vm.acceptType,
      "on-success": _vm.upScuccess
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "size": "small",
      "type": "primary",
      "id": "imgInput",
      "element-loading-text": "插入中,请稍候"
    }
  }, [_vm._v("点击上传")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.openPreview
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1119b265","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/course/LessonPreviewInsertModal.vue
// module id = 1642
// module chunks = 8